import React from 'react'
import FriendLabel from './FriendLabel'
import { InputError } from '@foodsby/nutrient'
import { SimpleSpinner } from '../common/SimpleSpinner'
import { NoFriendsAtLocation } from './FriendsSidebar'

const CurrentFriends = ({
  friends = [],
  isLoadingFriends,
  deleteCurrentFriend,
  deletingFriendError,
  loadFriendsError,
  isRespondingToFriendRequest,
  isLoadingFriendRequests,
  isCancelingOutgoingRequest
}) => {
  return (
    <div>
      {isLoadingFriendRequests ||
      isLoadingFriends ||
      isRespondingToFriendRequest ||
      isCancelingOutgoingRequest ? (
        <SimpleSpinner spinnerClass={{ spinnerSpace: true }} />
      ) : (
        <ul className="requestList">
          {friends && friends.length > 0
            ? friends.map((friend, i) => (
                <li className="requestListItem" key={i}>
                  <div className="col-xs-12">
                    <div className="col-xs-9 start-xs">
                      <FriendLabel
                        firstName={friend.firstName || ''}
                        lastName={friend.lastName || ''}
                        showName={
                          friend.firstName !== '' && friend.lastName !== ''
                        }
                        email={friend.email}
                        size="large"
                      />
                    </div>
                    <div className="col-xs-3 end-xs">
                      <button
                        className="link"
                        onClick={() => deleteCurrentFriend(friend.connectionId)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </li>
              ))
            : friends.length === 0 &&
              !loadFriendsError && <NoFriendsAtLocation friendManagerPage />}
        </ul>
      )}
      {deletingFriendError && (
        <InputError
          visible={deletingFriendError && deletingFriendError !== null}
        >
          {deletingFriendError}
        </InputError>
      )}
    </div>
  )
}

export default CurrentFriends
